module.exports = __webpack_public_path__ + "static/media/ty_dummies.fd69274c.jpeg";